export const dateTimeFormat = {
  de: {
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
}

export const datePickerLabels = {
  labelPrevDecade: 'Vorheriges Jahrzehnt',
  labelPrevYear: 'Vorheriges Jahr',
  labelPrevMonth: 'Vorheriger Monat',
  labelCurrentMonth: 'Aktueller Monat',
  labelNextMonth: 'Nächster Monat',
  labelNextYear: 'Nächstes Jahr',
  labelNextDecade: 'Nächstes Jahrzehnt',
  labelToday: 'Heute',
  labelSelected: 'Ausgewähltes Datum',
  labelNoDateSelected: 'Klicken um Datum auszuwählen',
  labelCalendar: 'Kalender',
  labelNav: 'Kalendernavigation',
  labelHelp: 'Mit den Pfeiltasten durch den Kalender navigieren',
  labelResetButton: 'Datum zurücksetzen',
}

export default {
  'about_respondeco.title': 'Über respondeco.org',
  'about_us.jan.citation': '«Eine andere Arbeitswelt ist möglich.»',
  'about_us.jan.description':
    'Jan Draxler wollte schon immer die Welt retten. Sowohl im Laufe seines privaten als auch beruflichen Lebens musste er sich davon schrittweise verabschieden.\n Trotzdem gab er nie auf. Er studierte Politikwissenschaften und Sozialwirtschaft, arbeitete als Vortragender, Sozialarbeiter und Projektmanager.\n\nDann wurden ihm zwei Kinder geschenkt und er bastelte an respondeco.org. Seitdem hat er wieder ein wenig Hoffnung geschöpft, vielleicht doch noch die Welt retten zu können.',
  'about_us.jan.title': 'Jan',
  'about_us.klaus.citation': '«Ernsthaft? nice!»',
  'about_us.klaus.description':
    'Für Klaus Harrer gibt es eigentlich nichts Uninteressantes. Egal ob es Wissenschaft, Sport , Musik oder Technik ist.\n Er studierte und arbeitete...\n\nNun will er sich auch noch mehr die Welt ansehen. Und die scheint genauso groß wie seine Interessen.',
  'about_us.klaus.title': 'Klaus',
  'account.confirmation.error.account_forbidden':
    'Ihr Account wurde erfolgreich bestätigt. Allerdings ist bei der automatischen Anmeldung ein Fehler aufgetreten. Versuchen Sie sich anzumelden und falls dies nicht funktioniert wenden Sie sich bitte an support@respondeco.org. Vielen Dank!',
  'account.confirmation.error.forbidden':
    'Der Bestätigungslink wurde bereits benutzt. Bitte melden Sie sich mit Ihren Zugangsdaten an.',
  'account.confirmation.error.no_token':
    'Der Bestätigungslink ist fehlerhaft. Wenden Sie sich bitte an support@respondeco.org und wir kümmern uns darum!',
  'account.confirmation.error.not_found':
    'Wir konnten Ihren Account leider nicht finden und bestätigen. Wenden Sie sich bitte an support@respondeco.org und wir kümmern uns darum!',
  'account.confirmation.loading': 'Ihr Account wird bestätigt...',
  'account.confirmation.successful':
    'Vielen Dank für die Bestätigung Ihres Accounts. Sie sind nun angemeldet.',
  'account.confirmation.successful_link': 'Weiter zur Vervollständigung Ihres Profils',
  'account.invalid_password': 'Passwort stimmt nicht überein',
  'account.password_change.failure.not_found': 'Der Bestätigungslink wurde bereits benutzt.',
  'account.password_change.failure.no_token':
    'Der Bestätigungslink ist fehlerhaft. Wenden Sie sich bitte an support@respondeco.org und wir kümmern uns darum!',
  'account.password_change.initiated': 'E-Mail zur Bestätigung wurde verschickt',
  'account.password_change.loading': 'Passwort wird aktualisiert',
  'account.password_change.successful':
    'Vielen Dank für die Bestätigung. Ihr Passwort wurde geändert.',
  'account.password_change.title': 'Passwortänderung',
  'administration.accounts.create_new_account.info': 'Neuen Account anlegen',
  'administration.accounts.filter_by': 'Nach Name suchen',
  'administration.accounts.impersonate': 'Als Benutzer ausgeben',
  'administration.accounts.mark_as_spam.lock.info': 'Als Spam markieren',
  'administration.accounts.mark_as_spam.unlock.info': 'Spam-Markierung aufheben',
  'administration.accounts.name': 'Account',
  'administration.accounts.reset_password.info': 'Passwort zurücksetzen',
  'administration.accounts.stop_impersonating': 'Stop impersonating',
  'administration.go': 'Zur Administration',
  'administration.create_account.buttons.ok': 'Account anlegen',
  'administration.create_account.dialog_title': 'Neuen Account anlegen',
  'administration.create_account.errors.organisation_exists':
    'Diese Organisation existiert bereits.',
  'administration.create_account.email.label': 'E-Mail',
  'administration.create_account.name.label': 'Name',
  'administration.reset_password.dialog_title': 'Passwort für den Account {name} zurücksetzen',
  'administration.reset_password.form.newPassword.label': 'Neues Passwort',
  'administration.reset_password.form.newPassword.placeholder': '',
  'administration.reset_password.form.passwordConfirmation.label': 'Bestätigung',
  'administration.reset_password.form.passwordConfirmation.placeholder':
    'Muss mit dem eingegebenen Passwort übereinstimmen',
  'administration.reset_password.form.suggestion.label': 'Vorschlag',
  'administration.reset_password.submit': 'Passwort übernehmen',
  'administration.reset_password.success': 'Neues Passwort wurde übernommen.',
  'administration.reset_password.suggest_new_password': 'Neues Passwort vorschlagen',
  'administration.success.managedAccount': 'Account wurde angelegt',
  'auth.logged_out_because_token_is_no_longer_valid': 'Sie wurden vom System abgemeldet.',
  'auth.unauthenticated': 'Bitte melden Sie sich erneut an',
  'branding.konstanz': '17 Ziele für Konstanz',
  'branding.respondeco': 'respondeco.org',
  'category.chooser.placeholder': 'Kategorie auswählen',
  'common.about_organisation': 'Mehr über {name} erfahren',
  'common.actions': 'Aktionen',
  'common.add': 'Hinzufügen',
  'common.add_entry': 'Eintrag hinzufügen',
  'common.add_resource': 'Datei hinzufügen',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'common.comments': 'Kommentare',
  'common.confirm': 'Bestätigen',
  'common.copy_to_clipboard.error': 'Mit STRG+C kopieren (konnte nicht automatisch kopiert werden)',
  'common.copy_to_clipboard.info': 'In die Zwischenablage kopieren',
  'common.copy_to_clipboard.success': 'Erfolgreich kopiert!',
  'common.createdAtTime': 'Erstellt am, um',
  'common.dialog.confirmRemoval': 'Bitte bestätigen Sie den Löschvorgang.',
  'common.dialog.nyi': 'Diese Funktionalität steht derzeit noch nicht zur Verfügung',
  'common.dialog.title.add': 'Eintrag hinzufügen',
  'common.dialog.title.confirmRemoval': 'Bestätigung',
  'common.dialog.title.edit': 'Eintrag bearbeiten',
  'common.dialog.title.nyi': 'Noch nicht implementiert',
  'common.drop.description':
    'Die ausgewählte Datei wird hochgeladen und steht in Zukunft in der Dateiverwaltung zur Verfügung|Die ausgewählten Dateien werden hochgeladen und stehen in Zukunft in der Dateiverwaltung zur Verfügung',
  'common.drop.title': 'Datei hochladen|Dateien hochladen',
  'common.edit': 'Bearbeiten',
  'common.email': 'E-Mail',
  'common.emptyList': 'Keine Ergebnisse',
  'common.error.unauthenticated': 'Nicht berechtigt für diese Aktion',
  'common.error.undefined': 'Unbekannter Fehler ist aufgetreten',
  'common.error.upload': 'Fehler beim Upload',
  'common.error.unknownVideoSource':
    'Unbekanntes Format. Bitte verwenden Sie die URL zu dem Video das Sie einfügen möchten (zur Zeit wird Vimeo und YouTube unterstützt).',
  'common.error.unsupportedVideoService':
    'Wir unterstützen derzeit nur das Einbinden von Vimeo- bzw YouTube-Videos.',
  'common.filter.apply': 'Filter übernehmen',
  'common.filter.categories': 'SDG',
  'common.filter.label': 'Filter',
  'common.filter.offer_types': 'Art des Angebots',
  'common.filter.page_size': 'Zeige:',
  'common.filter.reset': 'Filter zurücksetzen',
  'common.filter.toggle': 'Liste filtern',
  'common.form.error.controls.newPassword': 'Neues Passwort',
  'common.form.error.controls.passwordConfirmation': 'Bestätigung',
  'common.form.error.email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'common.form.error.maxLength': 'Maximal {max} Zeichen erlaubt (derzeit {value})',
  'common.form.error.minLength': 'Mindestens {min} Zeichen notwendig (derzeit {value})',
  'common.form.error.required': 'Pflichtfeld, bitte geben Sie einen Wert ein.',
  'common.form.error.sameAs':
    'Dieses Feld muss mit dem Feld <strong>{control}</strong> übereinstimmen',
  'common.image_dialog.aspect_ratio.free': 'Frei',
  'common.image_dialog.aspect_ratio.label': 'Seitenverhältnis wählen: ',
  'common.image_dialog.aspect_ratio.16_to_9': '16:9',
  'common.image_dialog.aspect_ratio.1_to_1': '1:1',
  'common.image_dialog.infos.aspect_ratio': 'Seitenverhältnis:',
  'common.loadMore': 'Mehr laden',
  'common.login': 'Login',
  'common.logout': 'Abmelden',
  'common.noImages': 'Noch keine Bilder hinzugefügt',
  'common.offer': 'Angebot | Angebote',
  'common.offers': 'Angebote',
  'common.ok': 'Ok',
  'common.organisation': 'Partner*in | Partner*innen',
  'common.pagination.next': 'Weiter',
  'common.pagination.previous': 'Zurück',
  'common.password': 'Passwort',
  'common.passwordConfirmation': 'Passwortbestätigung',
  'common.project': 'Erfolgsgeschichte|Erfolgsgeschichten',
  'common.ratings': 'Bewertungen',
  'common.read_more': 'Mehr erfahren',
  'common.register': 'Registrierung',
  'common.remove_entry': 'Eintrag entfernen',
  'common.reset': 'Zurücksetzen',
  'common.save': 'Speichern',
  'common.sdg': 'SDG',
  'common.sdgs': 'SDGs',
  'common.search_results.empty': 'Keine Einträge gefunden',
  'common.settings': 'Einstellungen',
  'common.stepper.back': 'Zurück',
  'common.stepper.next': 'Weiter',
  'common.stepper.submit': 'Abschicken',
  'common.stepper.nth_step_of': 'Schritt {step} / {total}',
  'common.success': 'Erfolg!',
  'common.successfulDelete': 'Erfolgreich gelöscht',
  'common.successfulSave': 'Erfolgreich gespeichert',
  'common.table.empty': 'Keine Einträge vorhanden',
  'common.table.emptyFilter': 'Keine Ergebnisse für den Filter: {filter}',
  'common.unsavedChanges': 'Ungespeicherte Änderungen',
  'cookie.action.opt_in': 'Cookies erlauben',
  'cookie.action.opt_out': 'Cookies ablehnen',
  'cookie.information': 'respondeco verwendet Cookies um Zugriffe auf die Webseite zu analysieren.',
  'development.settings.form.killUrls.info':
    'Format: "[optional hash to comment the line] [method] [url without host as regex] [json object that is used as response]',
  'development.settings.form.killUrls.label': 'URLs to kill',
  'development.settings.form.killUrls.placeholder':
    'URLs die nicht abgeschickt werden um Fehler zu simulieren',
  'engage.title': 'Aktiv werden',
  'filechooser.placeholder': 'Wähle eine Datei',
  footer: 'Wir vermitteln Nachhaltigkeit',
  'header.contact_respondeco': 'Kontakt aufnehmen',
  'header.logged_in_as': 'Angemeldet als',
  'header.login': 'Login',
  'header.register': 'Registrieren',
  'home.about_us': 'Über uns',
  'home.header.call_to_action': 'Mehr über respondeco.org',
  'home.header.sub': '',
  'home.header.sup': '',
  'home.header.title.first': 'Finden Sie nachhaltige Partner*innen',
  'home.header.title.fourth':
    'Wir vermitteln Nachhaltigkeit - <span class="apex-new">respondeco</span>',
  'home.header.title.second': 'Finden Sie nachhaltige Angebote',
  'home.header.title.third': 'Erzählen Sie Ihre Erfolgsgeschichte',
  'home.impact.description':
    '\n<p>Unseren Impact auf die Gesellschaft messen wir. Dabei orientieren wir uns an den SDGs. Besonders folgende sind für uns interessant.</p>\n\n<p><strong>12.6</strong> Die Unternehmen, insbesondere große und transnationale Unternehmen, dazu ermutigen, nachhaltige Verfahren einzuführen und in ihre Berichterstattung Nachhaltigkeitsinformationen aufzunehmen</p> \n\n<p><strong>12.8</strong> Bis 2030 sicherstellen, dass die Menschen überall über einschlägige Informationen und das Bewusstsein für nachhaltige Entwicklung und eine Lebensweise in Harmonie mit der Natur verfügen</p> \n\n<p><strong>17.16</strong> Die Globale Partnerschaft für nachhaltige Entwicklung ausbauen, ergänzt durch Multi-Akteur-Partnerschaften zur Mobilisierung und zum Austausch von Wissen, Fachkenntnissen, Technologie und finanziellen Ressourcen, um die Erreichung der Ziele für nachhaltige Entwicklung in allen Ländern und insbesondere in den Entwicklungsländern zu unterstützen</p> \n\n<p><strong>17.17</strong> Die Bildung wirksamer öffentlicher, öffentlich-privater und zivilgesellschaftlicher Partnerschaften aufbauend auf den Erfahrungen und Mittelbeschaffungsstrategien bestehender Partnerschaften unterstützen und fördern</p> \n\n<strong>KPI</strong>\n\n<ul>\n  <li>Anzahl von Partnerschaften, die durch respondeco zustande gekommen sind</li>\n  <li>Anzahl von Partnerschaftsseiten inklusive Learnings zu den Partnerschaften, um so neue Partnerschaften zu ermöglichen</li>\n  <li>Anzahl vermittelter nachhaltiger Dienstleistungen</li>\n  <li>Anzahl der Besucher*innen</li>\n  <li>Unique IPs</li>\n</ul>\n',
  'home.impact.title': 'Unser Impact',
  'home.meaning.mission.description':
    '\n<p>Diese Vision wollen wir verwirklichen, indem wir mit Unternehmen und social businesses sowie gemeinnützigen Organisationen zusammenarbeiten.</p>\n<p>respondeco hilft, die richtigen Partner*innen zusammenzuführen.</p>',
  'home.meaning.mission.title': 'Unsere Mission',
  'home.meaning.vision.description':
    '\n<p>In der heutigen Zeit fehlt es an positiven Visionen. Zum Glück gibt es Ausnahmen - die <a href="https://www.bundeskanzleramt.gv.at/themen/nachhaltige-entwicklung-agenda-2030.html">17 globalen Nachhaltigkeitsziele (SDGs) der Vereinten Nationen</a> sind so eine.</p>\n\n<blockquote class="blockquote">\n    "Wir sehen eine Welt vor uns, die frei von Armut, Hunger, Krankheit und Not ist und in der alles Leben gedeihen kann. Eine Welt, die frei von Furcht und Gewalt ist. Eine Welt, in der alle Menschen lesen und schreiben können... Eine Welt, in der die menschlichen Lebensräume sicher, widerstandsfähig und nachhaltig sind und in der alle Menschen Zugang zu bezahlbarer, verlässlicher und nachhaltiger Energie haben."\n    <footer class="blockquote-footer">(Auszug aus der Erklärung der Agenda 2030).</footer>\n</blockquote>  \n\n<p>Unsere Vision: Diese Ziele erreichen.</p>',
  'home.meaning.vision.title': 'Unsere Vision',
  'home.offers.discover': 'Alle Angebote',
  'home.offers.subtitle':
    'Entdecken Sie konkrete Umsetzungsmaßnahmen, die Ihrem Unternehmen zu mehr Nachhaltigkeit verhelfen, wie zum Beispiel Veranstaltungen, Projekte, Weiterbildungen oder Beratungen – genau auf Ihre Interessen und Ressourcen zugeschnitten.',
  'home.offers.title': 'Entdecken Sie Angebote',
  'home.organisations.discover': 'Alle Partner*innen',
  'home.organisations.subtitle':
    'Entdecken Sie Partner*innen, die Ihnen helfen, nachhaltiger zu werden.',
  'home.organisations.title': 'Entdecken Sie Partner*innen',
  'home.our_offers.communication.description':
    'Sie möchten Ihre <strong>Nachhaltigkeitsaktivitäten</strong> ansprechend und glaubwürdig kommunizieren und die <strong>Reputation</strong> Ihres Unternehmens erhöhen?<br>Wir helfen Ihnen, Ihre Leistungen glaubhaft und innovativ auf einer unabhängigen Plattform darzustellen.<br>Präsentieren Sie Ihre Projekte zusammen mit ihren Partner*innen, erzählen Sie positive Geschichten und erreichen Sie so neue Zielgruppen.<br>Damit Sie mit ihrer Erfolgsstory auch andere inspirieren.',
  'home.our_offers.communication.title': 'Kommunikation von Nachhaltigkeit',
  'home.our_offers.partners.description':
    '<p>Sie möchten nachhaltiger werden, dafür fehlen Ihnen aber Zeit und Ressourcen?</p>\n<p>Wir vermitteln Ihnen die für Sie passenden Expert*innen, wie Social Businesses, NGOs und Nachhaltigkeitsberater*innen.</p><p>Damit Sie sich auf Ihr Kerngeschäft konzentrieren und ganz einfach ein bisschen nachhaltiger werden können.</p>',
  'home.our_offers.partners.title': 'Partner*innen-Vermittlung',
  'home.our_principles.item1.description': 'Weil gemeinsam mehr Sinn macht',
  'home.our_principles.item1.title': 'Sozial',
  'home.our_principles.item2.description': 'Weil das unsere Geschäftsidee ist',
  'home.our_principles.item2.title': 'Nachhaltig',
  'home.our_principles.item3.description': 'Weil das fair ist',
  'home.our_principles.item3.title': 'Transparent',
  'home.our_principles.item4.description': 'Weil das gut ist',
  'home.our_principles.item4.title': 'Demokratisch',
  'home.our_values.heading': 'Engagement zeigen',
  'home.our_values.icon1.list.item1': 'Neue Zielgruppen',
  'home.our_values.icon1.list.item2': 'Herstellung gesellschaftlicher Legitimation',
  'home.our_values.icon1.list.item3': 'Unternehmensreputation und Glaubwürdigkeit',
  'home.our_values.icon1.message':
    'Ergänzen Sie ihre Nachhaltigkeitskommunikation mit einem vollkommen neuen Ansatz',
  'home.our_values.icon1.title': 'Erzähle',
  'home.our_values.icon2.message':
    'Finden Sie nachhaltige Angebote und verantwortungsvolle Partner*innen',
  'home.our_values.icon2.title': 'Finde',
  'home.our_values.icon3.message':
    'Präsentieren Sie ihre nachhaltigen Dienstleistungen wie Weiterbildungs- und Beratungsangebote, Veranstaltungen, Auszeichnungen und Zertifizierungen',
  'home.our_values.icon3.title': 'Zeige',
  'home.our_values.icon4.message':
    'Stellen Sie ihr nachhaltiges Angebot vor und sammeln Sie Ressourcen, die sie dafür brauchen',
  'home.our_values.icon4.title': 'Sammle',
  'home.slider.slide1.sub':
    '2015 hat die Welt einen Plan gemacht, wie wir unseren Planeten zu einem Ort machen,  an dem wir alle gerne leben wollen. Diese sogenannten <a href="https://www.bundeskanzleramt.gv.at/themen/nachhaltige-entwicklung-agenda-2030.html" title="Bundeskanzleramt / Nachhaltige Entwicklung – Agenda 2030 / SDGs">Sustainabilty Development Goals</a> (SDGs) sind deshalb so einzigartig, weil sie universell gültig sind und neben den drei Dimensionen Wirtschaft, Soziales und Ökologie die Wahrung der Menschenrechte, Rechtsstaatlichkeit, Good Governance, Frieden und Sicherheit einfordern.\nDie SDGs sprechen dabei ausdrücklich alle Organisationen an: Egal ob NGOs oder politische Organisationen, Gebietskörperschaften oder wissenschaftliche Einrichtungen. Multi oder Kleinunternehmen: Organisationen leisten bereits jetzt einen zentralen Beitrag für eine zukunftsfähige Welt und Wirtschaft von morgen.',
  'home.slider.slide1.title': 'Teil der weltweiten Nachhaltigkeitsaktivitäten',
  'home.slider.slide2.sub':
    'Schon seit Jahren setzen Sie in ihrer Organisation auf Nachhaltigkeit? Sie wollen über ihre Nachhaltigkeitsleistungen informieren?\nrespondeco.org hilft Ihnen Ihre Leistungen glaubhaft und einfach auf einer unabhängigen Plattform zu präsentieren. Stellen Sie ihre Projekte einfach und verständlich dar, erzählen Sie Geschichten und erreichen Sie so neue Zielgruppen.',
  'home.slider.slide2.title': 'Nachhaltigkeitskommunikation',
  'home.slider.slide3.sub':
    'Sie sind ein kleines Unternehmen und haben schon ein bisschen etwas Nachhaltiges gemacht? Und auch ihre Kunden achten zunehmend auf Nachhaltigkeit bei ihren Partnern? Nachhaltigkeit ist für sie zwar interessant, für ein systematisches Nachhaltigkeitsmanagement fehlt ihnen aber die Zeit und die Ressourcen? \nDank respondeco.org müssen sie sich nicht mehr aufwendig in das Thema Nachhaltigkeit einarbeiten, sondern sie können gleich loslegen. Mit Veranstaltungen, Projekten, Weiterbildungen oder Beratungen- ganz auf ihre Interessen und Ressourcen zugeschnitten.',
  'home.slider.slide3.title': 'Individualisierter CSR One Stop Shop',
  'home.slider.slide4.sub':
    'Nachhaltigkeit ist ihre Kernkompetenz- auch wenn Sie es vielleicht nicht so nennen?\nSie bieten Beratungen, Coachings, Workshops oder Schulungen in den Bereichen Umwelt, Führung, Diversity etc. an?\nAuf respondeco.org können Sie ihre Dienstleistungen kostenlos genau ihrer Zielgruppe präsentieren, egal ob es sich um kleine Unternehmen oder NGOs handelt. Damit noch mehr potentielle Kunden auf ihr nachhaltiges Angebot aufmerksam werden.  \nLaden sie ihre Kunden außerdem ein, ihre Arbeit durch Feedback zu unterstützen. Damit noch mehr potentielle Kunden von der Qualität ihres Angebots erfahren.',
  'home.slider.slide4.title': 'Empfehlungsmarketing',
  'home.slider.slide5.sub':
    'Sie sind Teil einer sozialen Initiative, Mitglied eines Vereins oder ein social business? Um die Welt noch ein bisschen besser machen zu können, fehlen ihnen aber Ressourcen? Ob Zeitspenden oder Sachspenden, auf respondeco.org finden Sie genau jene Unternehmen, die Sie bei ihren guten Taten unterstützen.',
  'home.slider.slide5.title': 'Crowdfundingplattform',
  'home.values.description':
    'Unser Angebot soll einen messbaren, erlebbaren, erfahrbaren Wert für unsere Kunden schaffen. Und da unsere Kunden alle Organisationen sind, die die Welt ein Stück nachhaltiger machen wollen, sind auch unsere Wertangebote vielfältig.',
  'home.values.title': 'Wertangebot',
  'http.status.200': 'OK',
  'http.status.400':
    'Ein Fehler ist aufgetreten (Fehlercode: {errorCode}). Bitte wenden Sie sich an support@respondeco.org und schicken Sie uns den Fehlercode mit.',
  'http.status.401':
    'Sie sind nicht mehr angemeldet. Bitte melden Sie sich erneut an um diese Aktion auszuführen.',
  'http.status.403': 'FORBIDDEN',
  'http.status.404': 'Nicht gefunden',
  'http.status.413': 'Die hochgeladene Datei ist zu groß (bis zu 8MB sind möglich).', // TODO handle premium upload size
  'http.status.500':
    'Ein Fehler ist aufgetreten (Fehlercode: {errorCode}). Bitte wenden Sie sich an support@respondeco.org und schicken Sie uns den Fehlercode mit.',
  'image.dialog.choose': 'Wähle ein Bild',
  'image.dialog.chooseAnother': 'Wähle ein anderes Bild',
  'image.dialog.orDragAndDrop': 'oder ziehe eines in das Fenster',
  'impressum.title': 'Impressum',
  'inbox.empty.placeholder': 'Chat auswählen um zu kommunizieren',
  'inbox.new_message.placeholder': 'Schreiben Sie eine Nachricht',
  'inbox.search_contacts': 'Nach Organisation suchen',
  'inbox.submit': 'Abschicken',
  'inbox.title': 'Posteingang',
  'landingPage.account_confirmed.description':
    'Vielen Dank für die Bestätigung Ihres Accounts, sie werden in wenigen Sekunden weitergeleitet.',
  'landingPage.account_confirmed.title': 'Ihr Account wurde erfolgreich bestätigt',
  'landingPage.password_changed.description':
    'Ihr Passwort wurde erfolgreich geändert, sie werden in wenigen Sekunden weitergeleitet.',
  'landingPage.password_changed.title': 'Ihr Passwort wurde erfolgreich geändert',
  'konstanz.offer.partners.heading': 'Eine Kooperation von',
  'konstanz.offer.settings.date.label': 'Termin',
  'konstanz.offer.settings.format.label': 'Format',
  'konstanz.offer.settings.location.label': 'Ort',
  'konstanz.offer.settings.partners.add': 'Kooperationspartner hinzufügen',
  'konstanz.offer.settings.partners.empty': 'Noch keine Kooperationspartner hinzugefügt',
  'konstanz.offer.settings.partners.title': 'Kooperationspartner',
  'konstanz.offer.settings.partners.table.organisation': 'Name des Kooperationspartners',
  'konstanz.organisation.menu.projects': 'Berichte',
  'konstanz.organisation.projects.edit': 'Bericht bearbeiten',
  'konstanz.project.edit.successful_save': 'Bericht erfolgreich gespeichert',
  'konstanz.project.partners.header': 'Veranstalter*innen',
  'konstanz.project.settings.back_to_project': 'Zum Bericht',
  'konstanz.project.settings.form.visible.label': 'Bericht veröffentlichen',
  'konstanz.project.settings.description.title': 'Beschreibung',
  'konstanz.project.settings.description.description': '',
  'konstanz.project.settings.partners.title': 'Kooperationspartner*innen',
  'konstanz.project.settings.partners.description': '',
  'konstanz.project.settings.learnings.description':
    'Hier können alle Mitveranstalter*innen und Kooperationspartner*innen ihr persönliches Feedback zu der Aktion geben. <br /> Nicht befüllte Felder werden nicht angezeigt.',
  'konstanz.project.settings.learnings.title': 'Erfahrungen/ Eindrücke',
  'konstanz.project.top_bar.edit':
    'Sie sind angemeldet und können diesen Bericht bearbeiten indem Sie hier klicken.',
  'konstanz.routes.organisation.projects': 'Berichte von {name}',
  'konstanz.routes.template': '{} | 17 Ziele für Konstanz',
  'login.error': 'Benutzername oder Passwort stimmen nicht mit unseren Aufzeichnungen überein.',
  'login.error.resetPassword': 'Passwort zurücksetzen',
  'login.go': 'Anmelden',
  'login.goToRegistration': 'Zur Registrierung',
  'login.notRegistered': 'Noch keinen Account?',
  'login.success': 'Erfolgreich angemeldet',
  'login.recover_password': 'Passwort vergessen?',
  'login.go_to_password_recovery': 'Passwort zurücksetzen',
  'logout.success': 'Erfolgreich abgemeldet',
  'lookup.category.BEZAHLBARE_UND_SAUBERE_ENERGIE': 'Bezahlbare und saubere Energie',
  'lookup.category.FRIEDEN_GERECHTIGKEIT_UND_STARKE_INSTITUTIONEN':
    'Frieden, Gerechtigkeit und starke Institutionen',
  'lookup.category.GESCHLECHTER_GLEICHHEIT': 'Geschlechter-Gleichheit',
  'lookup.category.GESUNDHEIT_UND_WOHLERGEHEN': 'Gesundheit und Wohlergehen',
  'lookup.category.HOCHWERTIGE_BILDUNG': 'Hochwertige Bildung',
  'lookup.category.INDUSTRIE_INNOVATION_UND_INFRASTRUKTUR':
    'Industrie, Innovation und Infrastruktur',
  'lookup.category.KEINE_ARMUT': 'Keine Armut',
  'lookup.category.KEIN_HUNGER': 'Kein Hunger',
  'lookup.category.LEBEN_AN_LAND': 'Leben an Land',
  'lookup.category.LEBEN_UNTER_WASSER': 'Leben unter Wasser',
  'lookup.category.MASSNAHMEN_ZUM_KLIMASCHUTZ': 'Maßnahmen zum Klimaschutz',
  'lookup.category.MENSCHENWUERDIGE_ARBEIT_UND_WIRTSCHAFTSWACHSTUM':
    'Menschenwürdige Arbeit und Wirtschaftswachstum',
  'lookup.category.NACHHALTIGE_R_KONSUM_UND_PRODUKTION': 'Nachhaltige/r Konsum und Produktion',
  'lookup.category.NACHHALTIGE_STAEDTE_UND_GEMEINDEN': 'Nachhaltige Städte und Gemeinden',
  'lookup.category.PARTNERSCHAFTEN_ZUR_ERREICHUNG_DER_ZIELE':
    'Partnerschaften zur Erreichung der Ziele',
  'lookup.category.SAUBERES_WASSER_UND_SANITAEREINRICHTUNGEN':
    'Sauberes Wasser und Sanitäreinrichtungen',
  'lookup.category.WENIGER_UNGLEICHHEITEN': 'Weniger Ungleichheiten',
  'lookup.offer_type.AUS_WEITERBILDUNG_WORKSHOPS_VERANSTALTUNGEN':
    'Aus- Weiterbildung/Workshops/Veranstaltungen',
  'lookup.offer_type.COACHING_BERATUNG': 'Coaching/Beratung',
  'lookup.offer_type.GOODIE': 'Goodie',
  'lookup.offer_type.PREISE_AUSZEICHNUNGEN': 'Preise/Auszeichnungen',
  'lookup.offer_type.SACHSPENDE_ZEITSPENDE_GELDSPENDE': 'Sachspende/Zeitspende/Geldspende',
  'lookup.offer_type.STANDARDS_ZERTIFIZIERUNGEN': 'Standards/Zertifizierungen',
  'lookup.organisation_type.GEBIETSKOERPERSCHAFT': 'Gebietskoerperschaft',
  'lookup.organisation_type.GROSSUNTERNEHMEN': 'Großunternehmen',
  'lookup.organisation_type.KLEINSTUNTERNEHMEN': 'Kleinstunternehmen',
  'lookup.organisation_type.KLEINUNTERNEHMEN': 'Kleinunternehmen',
  'lookup.organisation_type.MITTELUNTERNEHMEN': 'Mittelunternehmen',
  'lookup.organisation_type.NGO': 'Non-Profit-Organisation',
  'lookup.organisation_type.POLITISCHE_ORGANISATION': 'Politische Organisation',
  'lookup.organisation_type.SOCIALSTARTUP': 'Socialstartup',
  'lookup.organisation_type.WISSENSCHAFTLICHE_EINRICHTUNG': 'Wissenschaftliche Einrichtung',
  'lookup.sector.ADMINISTRATION_VERWALTUNG_BUEROWESEN': 'Administration/Verwaltung/Buerowesen',
  'lookup.sector.AUTOMOBIL_AUTOMOBILZULIEFERER': 'Automobil/Automobilzulieferer',
  'lookup.sector.BANKEN': 'Banken',
  'lookup.sector.BAUGEWERBE_ARCHITEKTUR': 'Baugewerbe/Architektur',
  'lookup.sector.BERATUNG_CONSULTING': 'Beratung/Consulting',
  'lookup.sector.BILDUNG': 'Bildung',
  'lookup.sector.CHEMIE': 'Chemie',
  'lookup.sector.DIENSTLEISTUNG': 'Dienstleistung',
  'lookup.sector.DRUCK_PAPIER_VERPACKUNG': 'Druck/Papier/Verpackung',
  'lookup.sector.EDV_IT': 'Edv/It',
  'lookup.sector.EINKAUF_BESCHAFFUNG': 'Einkauf/Beschaffung',
  'lookup.sector.ELEKTRO_ELEKTRONIK': 'Elektro/Elektronik',
  'lookup.sector.ENERGIEWIRTSCHAFT': 'Energiewirtschaft',
  'lookup.sector.FINANZEN': 'Finanzen',
  'lookup.sector.FORSCHUNG_ENTWICKLUNG_WISSENSCHAFT': 'Forschung/Entwicklung/Wissenschaft',
  'lookup.sector.GESUNDHEITSWESEN_SOZIALES_PFLEGE': 'Gesundheitswesen/Soziales/Pflege',
  'lookup.sector.HANDEL_KONSUM': 'Handel/Konsum',
  'lookup.sector.HANDWERK': 'Handwerk',
  'lookup.sector.IMMOBILIEN_FACILITY_MANAGEMENT': 'Immobilien/Facility/Management',
  'lookup.sector.INDUSTRIE': 'Industrie',
  'lookup.sector.INTERNET_MULTIMEDIA': 'Internet/Multimedia',
  'lookup.sector.KUNST_KULTUR_UNTERHALTUNG': 'Kunst/Kultur/Unterhaltung',
  'lookup.sector.MARKETING_WERBUNG_PR': 'Marketing/Werbung/Pr',
  'lookup.sector.MARKTFORSCHUNG': 'Marktforschung',
  'lookup.sector.MASCHINEN_ANLAGENBAU': 'Maschinen/Anlagenbau',
  'lookup.sector.MEDIEN': 'Medien',
  'lookup.sector.MEDIZINTECHNIK': 'Medizintechnik',
  'lookup.sector.MEDIZIN_PHARMA': 'Medizin/Pharma',
  'lookup.sector.NAHRUNGSMITTEL_LAND_FORSTWIRTSCHAFT': 'Nahrungsmittel/Land/Forstwirtschaft',
  'lookup.sector.PERSONALWESEN_PERSONALBESCHAFFUNG': 'Personalwesen/Personalbeschaffung',
  'lookup.sector.RECHTSBERATUNG': 'Rechtsberatung',
  'lookup.sector.SEMINAR_MESSEANBIETER': 'Seminar/Messeanbieter',
  'lookup.sector.SONSTIGE_BRANCHEN': 'Sonstige/Branchen',
  'lookup.sector.SPORT_FITNESS_BEAUTY': 'Sport/Fitness/Beauty',
  'lookup.sector.STEUERBERATUNG_WIRTSCHAFTSPRUEFUNG': 'Steuerberatung/Wirtschaftspruefung',
  'lookup.sector.TELEKOMMUNIKATION': 'Telekommunikation',
  'lookup.sector.TEXTILBRANCHE': 'Textilbranche',
  'lookup.sector.TOURISMUS_HOTEL_GASTRONOMIE': 'Tourismus/Hotel/Gastronomie',
  'lookup.sector.VERKEHR_TRANSPORT_LOGISTIK': 'Verkehr/Transport/Logistik',
  'lookup.sector.VERSICHERUNG': 'Versicherung',
  'menu.about': 'Über uns',
  'menu.about.impact': 'Unser Impact',
  'menu.about.mission_vision': 'Sinn der Sache',
  'menu.about.team': 'Das Team',
  'menu.call_to_action': 'Aktiv werden',
  'menu.impressum': 'Impressum',
  'menu.inbox': 'Posteingang',
  'menu.logout': 'Abmelden',
  'menu.myOffers': 'Meine Angebote',
  'menu.myProfile': 'Mein Profil',
  'menu.myProjects': 'Meine Erfolgsgeschichten',
  'menu.organisation_statistics': 'Profilbesuche',
  'menu.offer': 'Angebot {name}',
  'menu.offers': 'Angebote',
  'menu.organisations': 'Partner*innen',
  'menu.projects': 'Erfolgsgeschichten',
  'menu.resources': 'Dateiverwaltung',
  'menu.settings': 'Profil bearbeiten',
  'menu.value': 'Wertangebot',
  'offer.add': 'Neues Angebot erstellen',
  'offer.an_offer_by': 'Ein Angebot von',
  'offer.back_to_offer': 'Zum Angebot',
  'offer.contact': '{name} kontaktieren',
  'offer.delete.action': 'Angebot löschen',
  'offer.delete.confirmation': 'Bitte bestätigen Sie das Löschen dieses Angebots.',
  'offer.delete.info': '',
  'offer.delete.label': 'Angebot löschen',
  'offer.description.title': 'Beschreibung',
  'offer.edit.button': 'Angebot bearbeiten',
  'offer.edit.title': '"{name}" bearbeiten',
  'offer.form.audience': 'Zielgruppe',
  'offer.form.categories': 'SDGs',
  'offer.form.description': 'Beschreibung',
  'offer.form.headerImage': 'Titelbild',
  'offer.form.name': 'Name',
  'offer.form.logo.description': 'Logo ändern',
  'offer.form.logo.dialog_title': 'Logo für das Angebot wählen',
  'offer.form.logo.help': 'Das Logo wird in der Angebotsübersicht angezeigt.',
  'offer.form.logo.label': 'Logo',
  'offer.form.offer_type': 'Typ des Angebots',
  'offer.form.partners': 'Partner*innen',
  'offer.form.sector': 'Branche der Zielgruppe',
  'offer.form.sector_info':
    'Falls sich Ihr Angebot an Partner*innen aus einer bestimmen Branche richtet, dann definieren Sie diese hier. Keine Branche bedeutet, dass sich dieses Angebot an Partner*innen aller Branchen richtet.',
  'offer.form.short_description': 'Kurzbeschreibung',
  'offer.form.short_description.help':
    'Die Kurzbeschreibung wird in der Angebotsübersicht angezeigt.',
  'offer.form.type': 'Angebotstyp',
  'offer.go_to_report': 'Zum Bericht',
  'offer.new.action': 'Erzähle mehr über dein Angebot!',
  'offer.new.changeImage': 'Ändere das Bild',
  'offer.new.chooseImage': 'Füge ein Bild hinzu',
  'offer.new.content': '...',
  'offer.new.title': 'Neues Angebot erstellen',
  'offer.partners.add': 'Partner*in hinzufügen',
  'offer.partners.dialog.title': 'Neuen Partner*in hinzufügen',
  'offer.partners.heading': 'Partner*innen die dieses Angebot in Anspruch genommen haben',
  'offer.partners.image.alt': 'Logo von {name}',
  'offer.partners.listTitle': 'Partner*in',
  'offer.partners.placeholder': 'Partner*in suchen',
  'offer.partners.remove': 'Partner*in entfernen',
  'offer.placeholder.description': 'Geben Sie hier die Beschreibung des Angebots ein',
  'offer.placeholder.name': 'Geben Sie hier den Namen des Angebots ein',
  'offer.post.pin': 'Anpinnen',
  'offer.post.unpin': 'Loslösen',
  'offer.posts.heading': 'Community',
  'offer.public.label': 'Angebot veröffentlichen',
  'offer.report.settings.title.edit': 'Bericht für "{name}"',
  'offer.save': 'Angebot speichern',
  'offer.sdgs': 'SDGs',
  'offer.settings.about.description':
    'Befüllen Sie hier die wichtigsten Informationen über das Angebot.',
  'offer.settings.about.title': 'Allgemeine Infos',
  'offer.settings.description.description': 'Beschreiben Sie hier Ihr Angebot näher.',
  'offer.settings.description.title': 'Beschreibung des Angebots',
  'offer.settings.header.add_entry': 'Bild hinzufügen',
  'offer.settings.header.description':
    'Wählen Sie ein oder mehrere Bilder die als Titelbild(er) verwendet werden sollen.',
  'offer.settings.header.remove_entry': 'Bild entfernen',
  'offer.settings.header.title': 'Titelbild(er)',
  'offer.settings.partners.description':
    'Liste aller Organisationen die dieses Angebot bisher in Anspruch genommen haben.',
  'offer.settings.partners.title': 'Partner*innen',
  'offer.settings.partners.table.date': 'In Anspruch genommen am',
  'offer.settings.partners.table.organisation': 'In Anspruch genommen von',
  'offer.settings.partners.table.actions.remove': 'Partner entfernen',
  'offer.settings.report.create': 'Bericht erstellen',
  'offer.settings.report.edit': 'Bericht bearbeiten',
  'offer.settings.title.edit': 'Angebot "{name}"',
  'offer.settings.title.new': 'Neues Angebot erstellen',
  'offer.share': 'Teilen:',
  'offer.sidebar.label.description': 'Beschreibung',
  'offer.sidebar.label.organisation': 'Organisation',
  'offer.sidebar.label.partners': 'Partner-Organisationen',
  'offer.topBar.delete': 'Angebot entfernen',
  'offer.topBar.edit':
    'Sie befinden sich im angemeldeten Zustand und können dieses Angebot bearbeiten indem Sie hier klicken.',
  'offer.topBar.partners':
    'Als Partner*in des Projekts können Sie Nachrichten posten und von Ihnen gepostete Nachrichten bearbeiten',
  'offers.filter.apply': 'Filter übernehmen',
  'offers.filter.categories': 'SDG',
  'offers.filter.offer_types': 'Art des Angebots',
  'offers.filter.page_size': 'Zeige:',
  'offers.filter.reset': 'Filter zurücksetzen',
  'offers.item.call_to_action': 'Mehr erfahren',
  'offers.placeholder': 'Suchen Sie nach Titel, Ort oder Organisation',
  'organisation.activities.title': 'Aktivitäten',
  'organisation.activities.description':
    'Die folgenden Angebote hat {name} bisher in Anspruch genommen.',
  'organisation.activities.empty': '{name} hat bisher keine Angebote in Anspruch genommen.',
  'organisation.activity.callToAction': 'Mehr erfahren',
  'organisation.chooser.placeholder': 'Wählen Sie eine Organisation',
  'organisation.failure_code.409':
    'Der Name ist bereits in Verwendung. Bitte melden Sie sich bei support@respondeco.org, wenn es sich um Ihr Unternehmen/ Ihre Organisation handelt.',
  'organisation.interactions.title': 'Interaktionen',
  'organisation.interactions.description':
    'Mit den folgenden Partner*innen hat {name} bisher interagiert.',
  'organisation.interactions.empty': '{name} hat bisher mit keinen Partner*innen interagiert.',
  'organisation.interaction.callToAction': 'Mehr erfahren',
  'organisation.menu.about': 'Über uns',
  'organisation.menu.activities': 'Aktivitäten',
  'organisation.menu.interactions': 'Interaktionen',
  'organisation.menu.offers': 'Angebote',
  'organisation.menu.profile_settings': 'Profil bearbeiten',
  'organisation.menu.projects': 'Erfolgsgeschichten',
  'organisation.menu.statistics': 'Profilbesuche',
  'organisation.offers.buttons.create_new_offer': 'Neues Angebot erstellen',
  'organisation.offers.buttons.edit_offer': 'Angebot bearbeiten',
  'organisation.posts.heading': 'Community',
  'organisation.projects.edit': 'Erfolgsgeschichte bearbeiten',
  'organisation.settings.contact': 'Kontakt',
  'organisation.settings.description': 'Beschreibung',
  'organisation.settings.description.info':
    'Beschreiben Sie hier Ihre Organisation genauer. Falls Sie die Beschreibung nicht befüllen wird bei "Über die Organisation" die Kurzbeschreibung angezeigt.',
  'organisation.settings.logo.description': 'Logo ändern',
  'organisation.settings.logo.dialog_title': 'Logo für die Organisation wählen',
  'organisation.settings.logo.label': 'Logo',
  'organisation.settings.location': 'Standort',
  'organisation.settings.name': 'Name der Organisation',
  'organisation.settings.profile.description':
    'Hier können Sie allgemeine Informationen Ihrer Organisation bearbeiten.',
  'organisation.settings.profile.title': 'Profil',
  'organisation.settings.public': 'Profil veröffentlichen',
  'organisation.settings.sdgs': 'SDGs',
  'organisation.settings.sector': 'Branche',
  'organisation.settings.sector_info':
    'Definieren Sie hier in welcher Branche Ihre Organisation/ Ihr Unternehmen operiert. respondeco verwendet diese Information für das Matching zwischen Angeboten und Partner*innen (Angebote können sich an eine bestimmte Branche als Zielgruppe richten).',
  'organisation.settings.security.description': 'Hier können Sie Ihr Passwort ändern.',
  'organisation.settings.security.password.badRequest':
    'Neues Passwort stimmt nicht mit der Bestätigung überein',
  'organisation.settings.security.password.current': 'Derzeitiges Passwort',
  'organisation.settings.security.password.forbidden':
    'Derzeitiges Passwort stimmt nicht mit unseren Aufzeichnungen überein',
  'organisation.settings.security.password.new': 'Neues Passwort',
  'organisation.settings.security.password.verify': 'Passwort bestätigen',
  'organisation.settings.security.title': 'Sicherheitseinstellungen',
  'organisation.settings.short_description': 'Kurzbeschreibung',
  'organisation.settings.short_description.help':
    'Die Kurzbeschreibung wird in der Partner*innen-Übersicht angezeigt.',
  'organisation.settings.type': 'Typ der Organisation',
  'organisation.settings.update.errors.organisation_exists': 'Dieser Name ist bereits vergeben',
  'organisation.settings.vision': 'Vision',
  'organisation.settings.vision.info':
    'Die Vision wird bei "Über die Organisation" unter der Beschreibung angezeigt.',
  'organisation.settings.website': 'Webseite',
  'organisation.statistics.empty': 'Derzeit stehen noch keine Statistiken zur Verfügung',
  'organisation.statistics.heading':
    'Profilbesuche ({numberOfVisits} Aufruf)|Profilbesuche ({numberOfVisits} Aufrufe)',
  'organisation.vision': 'Vision',
  'organisations.filter.apply': 'Filter übernehmen',
  'organisations.filter.categories': 'SDG',
  'organisations.filter.organisation_types': 'Art der Organisation',
  'organisations.filter.page_size': 'Zeige:',
  'organisations.filter.reset': 'Filter zurücksetzen',
  'organisations.item.call_to_action': 'Mehr erfahren',
  'organisations.placeholder': 'Suchen Sie nach dem Namen einer Organisation',
  'paginated.filter.headings.categories': 'Kategorien',
  'paginated.filter.headings.price': 'Preis',
  'paginated.filter.headings.status': 'Status',
  'paginated.filter.price.charged': 'Kostenpflichtig',
  'paginated.filter.price.free': 'Gratis',
  'paginated.filter.reset': 'Filter zurücksetzen',
  'paginated.filter.status.done': 'Abgeschlossen',
  'paginated.filter.status.open': 'Offen',
  'password_recovery.title': 'Passwort zurücksetzen',
  'password_recovery.explanation': 'Geben Sie Ihre E-Mail-Adresse ein.',
  'password_recovery.back_to_login': 'Zurück zum Login',
  'password_recovery.could_not_send':
    'Die E-Mail für das Zurücksetzen des Passworts konnte nicht verschickt werden.',
  'password_recovery.go_to_login': 'Zum Login',
  'password_recovery.messages.resent_token':
    'Ein neuer Authentifizierungscode wurde an <strong>{email}</strong> verschickt. Geben Sie diesen bitte in das nachstehende Feld ein. Der Authentifizierungscode ist wieder für zwei Stunden gültig.',
  'password_recovery.messages.sent_mail':
    'Eine E-Mail mit einem Authentifizierungscode wurde soeben an <strong>{email}</strong> verschickt. Geben Sie diesen bitte in das nachstehende Feld ein. Der Authentifizierungscode ist für zwei Stunden gültig.',
  'password_recovery.messages.token_expired':
    'Der angegebene Authentifizierungscode ist nicht mehr gültig.',
  'password_recovery.messages.token_valid':
    'Geben Sie bitte ein neues Passwort ein und bestätigen Sie dieses. Das neue Passwort muss zumindest 8 Zeichen lang sein.',
  'password_recovery.password.title': 'Neues Passwort',
  'password_recovery.step1.form.email.label': 'E-Mail-Adresse',
  'password_recovery.step1.form.email.placeholder': 'E-Mail-Adresse',
  'password_recovery.step1.action': 'Passwort zurücksetzen',
  'password_recovery.step1.title': 'Passwort zurücksetzen',
  'password_recovery.step2.action': 'Authentifizierungscode prüfen',
  'password_recovery.step2.form.token.label': 'Authentifizierungscode',
  'password_recovery.step2.resend_token': 'Neuen Code anfordern',
  'password_recovery.step2.title': 'Authentifizierungscode',
  'password_recovery.step3.form.confirmation.label': 'Passwort bestätigen',
  'password_recovery.step3.form.password.label': 'Neues Passwort',
  'password_recovery.step3.action': 'Neues Passwort setzen',
  'password_recovery.success':
    'Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich nun mit Ihren neuen Zugangsdaten anmelden.',
  'password_recovery.token_expired': 'Authentifizierungscode ist nicht mehr gültig',
  'post.add': 'Als neuen Beitrag speichern',
  'post.author.image.alt': 'Logo von {name}',
  'post.create': 'Verfassen Sie einen neuen Kommentar',
  'post.delete': 'Kommentar löschen',
  'post.edit': 'Kommentar bearbeiten',
  'post.reply': 'Auf diesen Kommentar antworten',
  'post.save': 'Kommentar speichern',
  'post.submit': 'Kommentar abschicken',
  'post.successfulCreate': 'Kommentar wurde hinzugefügt.',
  'post.successfulDelete': 'Kommentar wurde gelöscht.',
  'post.successfulUpdate': 'Kommentar wurde aktualisiert.',
  'project.a_project_by': 'Eine Erfolgsgeschichte zwischen',
  'project.add': 'Neue Erfolgsgeschichte erstellen',
  'project.description_written_by': 'verfasst von respondeco.org',
  'project.edit.form.categories.label': 'SDGs',
  'project.edit.form.logo.description': 'Logo ändern',
  'project.edit.form.logo.dialog_title': 'Logo für die Erfolgsgeschichte wählen',
  'project.edit.form.logo.label': 'Logo',
  'project.edit.successful_save': 'Erfolgsgeschichte wurde erfolgreich gespeichert',
  'project.failure_code.409':
    'Der Name ist bereits in Verwendung. Verwenden Sie bitte einen anderen.',
  'project.gallery': 'Galerie',
  'project.gallery.add_image': 'Bild zur Galerie hinzufügen',
  'project.header.add_image': 'Titelbild hinzufügen',
  'project.new.categories.label': 'SDGs',
  'project.new.logo.change': 'Logo ändern',
  'project.new.logo.choose_new': 'Logo wählen',
  'project.new.logo.title': 'Logo für die Erfolgsgeschichte wählen',
  'project.partners.header': 'Eine Partnerschaft von',
  'project.posts.heading': 'Community',
  'project.settings.about.description':
    'Befüllen Sie hier die wichtigsten Informationen über die Erfolgsgeschichte.',
  'project.settings.about.title': 'Allgemeine Infos',
  'project.settings.back_to_project': 'Zur Erfolgsgeschichte',
  'project.settings.button': 'Erfolgsgeschichte bearbeiten',
  'project.settings.description.description':
    'Beschreiben Sie hier worum es bei der Erfolgsgeschichte ging.',
  'project.settings.description.title': 'Beschreibung der Erfolgsgeschichte',
  'project.settings.form.description.label': 'Beschreibung',
  'project.settings.form.description.placeholder': 'Beschreibung der Erfolgsgeschichte',
  'project.settings.form.logo.label': 'Logo',
  'project.settings.form.logo.placeholder': '',
  'project.settings.form.name.label': 'Name',
  'project.settings.form.name.placeholder': 'Name der Erfolgsgeschichte',
  'project.settings.form.shortDescription.label': 'Kurzbeschreibung',
  'project.settings.form.shortDescription.placeholder':
    'Beschreibung die in der Übersicht angezeigt wird',
  'project.settings.form.visible.label': 'Erfolgsgeschichte öffentlich',
  'project.settings.gallery.add_entry': 'Bild hinzufügen',
  'project.settings.gallery.description':
    'Wählen Sie ein oder mehrere Bilder die in der Galerie angezeigt werden sollen.',
  'project.settings.gallery.remove_entry': 'Bild entfernen',
  'project.settings.gallery.title': 'Galerie',
  'project.settings.header.add_entry': 'Bild hinzufügen',
  'project.settings.header.description':
    'Wählen Sie ein oder mehrere Bilder die als Titelbild(er) verwendet werden sollen.',
  'project.settings.header.remove_entry': 'Bild entfernen',
  'project.settings.header.title': 'Titelbild(er)',
  'project.settings.learnings.add': 'Learning hinzufügen',
  'project.settings.learnings.description':
    'Übersicht über die Learnings der verschiedenen Partner*innen',
  'project.settings.learnings.edit': 'Learning bearbeiten',
  'project.settings.learnings.empty': 'Learning wurde noch nicht hinzugefügt.',
  'project.settings.learnings.title': 'Learnings',
  'project.settings.logo.change': 'Logo ändern',
  'project.settings.logo.new': 'Logo auswählen',
  'project.settings.partners.add': 'Partner*innen hinzufügen',
  'project.settings.partners.description': 'Partner*innen der Erfolgsgeschichte',
  'project.settings.partners.empty': 'Noch keine Partner*innen hinzugefügt',
  'project.settings.partners.image_alt': 'Logo von {name}',
  'project.settings.partners.remove': 'Partner*in entfernen',
  'project.settings.partners.title': 'Partner*innen',
  'project.settings.step.1.description':
    'Definieren Sie hier die Basis-Infos wie Name, eine kurze Beschreibung, etc.',
  'project.settings.step.1.title': 'Erfolgsgeschichte',
  'project.settings.step.2.description':
    'Beschreiben Sie hier worum es bei der Erfolgsgeschichte ging.',
  'project.settings.step.2.title': '"{name}" beschreiben',
  'project.settings.step.3.description':
    'Wählen Sie ein oder mehrere Bilder die als Titelbild(er) verwendet werden sollen.',
  'project.settings.step.3.title': 'Titelbild(er) auswählen',
  'project.settings.submit': 'Erfolgsgeschichte speichern',
  'project.settings.title.edit': 'Erfolgsgeschichte "{name}"',
  'project.settings.title.new': 'Neue Erfolgsgeschichte erstellen',
  'project.top_bar.edit':
    'Sie befinden sich im angemeldeten Zustand und können diese Erfolgsgeschichte bearbeiten indem Sie hier klicken.',
  'projects.filter.apply': 'Filter übernehmen',
  'projects.filter.categories': 'SDG',
  'projects.filter.reset': 'Filter zurücksetzen',
  'projects.item.call_to_action': 'Mehr erfahren',
  'projects.meta.title': 'Projektübersicht',
  'registration.errors.organisation_exists': 'Eine Organisation mit diesem Namen existiert bereits',
  'registration.errors.user_already_registered':
    'Ein Benutzer mit dieser E-Mail Adresse existiert bereits',
  'registration.errors.user_creation_failed': 'Bei der Registrierung ist ein Fehler aufgetreten',
  'registration.existingAccount': 'Bereits angemeldet?',
  'registration.go': 'Registrieren',
  'registration.login': 'Zum Login',
  'registration.partnerName': 'Partner*in (Name des Unternehmens/ der Organisation)',
  'registration.success':
    'Registrierung war erfolgreich und ein E-Mail zur Bestätigung wurde verschickt',
  'resource.gallery.item_already_added': 'Das ausgewählte Bild wird bereits verwendet.',
  'resource.title': 'Ausschnitte',
  'resources.actions.add_variant.description': 'Ausschnitt hinzufügen',
  'resources.actions.add_variant.failure': 'Beim Erstellen ist ein Fehler aufgetreten ({id})',
  'resources.actions.add_variant.success': 'Neuer Ausschnitt wurde erfolgreich erstellt',
  'resources.actions.delete.action': 'Datei löschen',
  'resources.actions.delete.failure':
    'Datei konnte nicht gelöscht werden weil sie derzeit verwendet wird.',
  'resources.actions.delete.success': 'Datei wurde erfolgreich gelöscht',
  'resources.actions.delete.undo': 'Datei wiederherstellen',
  'resources.actions.delete_variant.action': 'Ausschnitt löschen',
  'resources.actions.delete_variant.failure':
    'Ausschnitt konnte nicht gelöscht werden weil sie derzeit verwendet wird.',
  'resources.actions.delete_variant.success': 'Ausschnitt wurde erfolgreich gelöscht',
  'resources.actions.delete_variant.undo': 'Ausschnitt wiederherstellen',
  'resources.actions.edit': 'Datei umbenennen',
  'resources.actions.restore.failure': 'Datei konnte nicht wiederhergestellt werden',
  'resources.actions.restore.success': 'Datei wurde erfolgreich wiederhergestellt',
  'resources.actions.restore_variant.failure': 'Ausschnitt konnte nicht wiederhergestellt werden',
  'resources.actions.restore_variant.success': 'Ausschnitt wurde erfolgreich wiederhergestellt',
  'resources.actions.show_variants': 'Ausschnitte anzeigen',
  'resources.actions.tooltip': 'Aktionen',
  'resources.create.upload_failed.wrongFileType': 'Dateityp ist nicht erlaubt',
  'resources.create.rejected_the_following_files':
    'Die folgende Datei kann nicht hochgeladen werden: |Die folgenden Dateien können nicht hochgeladen werden:',
  'resources.create.rejected_because': '{name}: <strong>{reason}</strong>',
  'resources.create.rejected_because.tooLarge': 'Zu groß',
  'resources.create.rejected_because.wrongFileType': 'Dateityp ist nicht erlaubt',
  'resources.create_new': 'Datei hochladen',
  'resources.create_new_image': 'Bild hochladen',
  'resources.dialog.form.location.label': 'Youtube Video',
  'resources.dialog.form.location.placeholder': 'ID oder URL oder Embed-URL zu einem Youtube Video',
  'resources.dialog.title.image': 'Bild aus Bibliothek auswählen',
  'resources.dialog.title.video': 'Variante auswählen',
  'resources.empty': 'Noch keine Dateien hinzugefügt',
  'resources.empty_images': 'Noch keine Bilder hinzugefügt',
  'resources.empty_images.description': 'Laden Sie Ihr erstes Bild hoch',
  'resources.empty_images.action': 'Laden Sie Ihr erstes Bild hoch',
  'resources.rename.form.description.label': 'Beschreibung',
  'resources.rename.form.description.placeholder': 'Beschreibung der Datei',
  'resources.rename.form.name.label': 'Neuer Name',
  'resources.rename.form.name.placeholder': 'Neuer Name der Datei',
  'resources.rename.ok': 'Speichern',
  'resources.rename.title': 'Datei umbenennen',
  'resources.title': 'Dateiverwaltung',
  'resources.variants.empty': 'Noch keine Ausschnitte für dieses Bild hinzugefügt',
  'routes.auth.forbidden':
    'Aufgrund von fehlenden Berechtigungen kann die Seite nicht aufgerufen werden',
  'routes.about.impact': 'Unser Impact',
  'routes.about.mission-vision': 'Sinn der Sache',
  'routes.about.team': 'Das Team',
  'routes.administration': 'Administration',
  'routes.home': 'Willkommen!',
  'routes.impressum': 'Impressum',
  'routes.inbox': 'Posteingang',
  'routes.login': 'Login',
  'routes.konstanz': 'Willkommen!',
  'routes.konstanz.organisation.projects': 'Aktionsberichte von {name}',
  'routes.offer': '{name} | {organisation}',
  'routes.offers': 'Angebote',
  'routes.organisation.about': 'Über {name}',
  'routes.organisation.activities': 'Aktivitäten von {name}',
  'routes.organisation.interactions': 'Interaktionen von {name}',
  'routes.organisation.offers': 'Angebote von {name}',
  'routes.organisation.projects': 'Erfolgsgeschichten von {name}',
  'routes.organisation.settings.profile': 'Profil',
  'routes.organisation.settings.security': 'Sicherheit',
  'routes.organisations': 'Übersicht Organisationen',
  'routes.projects': 'Erfolgsgeschichten',
  'routes.project': '{name}',
  'routes.recover_password': 'Passwort zurücksetzen',
  'routes.registration': 'Registrierung',
  'routes.resources': 'Dateiverwaltung',
  'routes.template': '{} | respondeco.org',
  'sdg.descriptions.BEZAHLBARE_UND_SAUBERE_ENERGIE':
    'Zugang zu bezahlbarer, verlässlicher, nachhaltiger und moderner Energie für alle sichern',
  'sdg.descriptions.FRIEDEN_GERECHTIGKEIT_UND_STARKE_INSTITUTIONEN':
    'Friedliche und inklusive Gesellschaften für eine nachhaltige Entwicklung fördern, allen Menschen Zugang zur Justiz ermöglichen und leistungsfähige, rechenschaftspflichtige und inklusive Institutionen auf allen Ebenen aufbauen',
  'sdg.descriptions.GESCHLECHTER_GLEICHHEIT':
    'Geschlechtergleichstellung erreichen und alle Frauen und Mädchen zur Selbstbestimmung befähigen',
  'sdg.descriptions.GESUNDHEIT_UND_WOHLERGEHEN':
    'Ein gesundes Leben für alle Menschen jeden Alters gewährleisten und ihr Wohlergehen fördern',
  'sdg.descriptions.HOCHWERTIGE_BILDUNG':
    'Inklusive, gleichberechtigte und hochwertige Bildung gewährleisten und Möglichkeiten lebenslangen Lernens für alle fördern',
  'sdg.descriptions.INDUSTRIE_INNOVATION_UND_INFRASTRUKTUR':
    'Eine widerstandsfähige Infrastruktur aufbauen, breitenwirksame und nachhaltige Industrialisierung fördern und Innovationen unterstützen',
  'sdg.descriptions.KEINE_ARMUT': 'Armut in allen ihren Formen und überall beenden.',
  'sdg.descriptions.KEIN_HUNGER':
    'Den Hunger beenden, Ernährungssicherheit und eine bessere Ernährung erreichen und eine nachhaltige Landwirtschaft fördern.',
  'sdg.descriptions.LEBEN_AN_LAND':
    'Landökosysteme schützen, wiederherstellen und ihre nachhaltige Nutzung fördern, Wälder nachhaltig bewirtschaften, Wüstenbildung bekämpfen, Bodendegradation beenden und umkehren und dem Verlust der biologischen Vielfalt ein Ende setzen',
  'sdg.descriptions.LEBEN_UNTER_WASSER':
    'Ozeane, Meere und Meeresressourcen im Sinne nachhaltiger Entwicklung erhalten und nachhaltig nutzen',
  'sdg.descriptions.MASSNAHMEN_ZUM_KLIMASCHUTZ':
    'Umgehend Maßnahmen zur Bekämpfung des Klimawandels und seiner Auswirkungen ergreifen',
  'sdg.descriptions.MENSCHENWUERDIGE_ARBEIT_UND_WIRTSCHAFTSWACHSTUM':
    'Dauerhaftes, breitenwirksames und nachhaltiges Wirtschaftswachstum, produktive Vollbeschäftigung und menschenwürdige Arbeit für alle fördern',
  'sdg.descriptions.NACHHALTIGE_R_KONSUM_UND_PRODUKTION':
    'Nachhaltige Konsum- und Produktionsmuster sicherstellen',
  'sdg.descriptions.NACHHALTIGE_STAEDTE_UND_GEMEINDEN':
    'Städte und Siedlungen inklusiv, sicher, widerstandsfähig und nachhaltig gestalten',
  'sdg.descriptions.PARTNERSCHAFTEN_ZUR_ERREICHUNG_DER_ZIELE':
    'Umsetzungsmittel stärken und die Globale Partnerschaft für nachhaltige Entwicklung mit  neuem Leben erfüllen',
  'sdg.descriptions.SAUBERES_WASSER_UND_SANITAEREINRICHTUNGEN':
    'Verfügbarkeit und nachhaltige Bewirtschaftung von Wasser und Sanitärversorgung für alle gewährleisten',
  'sdg.descriptions.WENIGER_UNGLEICHHEITEN': 'Ungleichheit in und zwischen Ländern verringern',
  'sdg.titles.BEZAHLBARE_UND_SAUBERE_ENERGIE': 'Bezahlbare und saubere Energie',
  'sdg.titles.FRIEDEN_GERECHTIGKEIT_UND_STARKE_INSTITUTIONEN':
    'Frieden, Gerechtigkeit und starke Institutionen',
  'sdg.titles.GESCHLECHTER_GLEICHHEIT': 'Geschlechter-Gleichheit',
  'sdg.titles.GESUNDHEIT_UND_WOHLERGEHEN': 'Gesundheit und Wohlergehen',
  'sdg.titles.HOCHWERTIGE_BILDUNG': 'Hochwertige Bildung',
  'sdg.titles.INDUSTRIE_INNOVATION_UND_INFRASTRUKTUR': 'Industrie, Innovation und Infrastruktur',
  'sdg.titles.KEINE_ARMUT': 'Keine Armut',
  'sdg.titles.KEIN_HUNGER': 'Kein Hunger',
  'sdg.titles.LEBEN_AN_LAND': 'Leben an Land',
  'sdg.titles.LEBEN_UNTER_WASSER': 'Leben unter Wasser',
  'sdg.titles.MASSNAHMEN_ZUM_KLIMASCHUTZ': 'Maßnahmen zum Klimaschutz',
  'sdg.titles.MENSCHENWUERDIGE_ARBEIT_UND_WIRTSCHAFTSWACHSTUM':
    'Menschenwürdige Arbeit und Wirtschaftswachstum',
  'sdg.titles.NACHHALTIGE_R_KONSUM_UND_PRODUKTION': 'Nachhaltige/r Konsum und Produktion',
  'sdg.titles.NACHHALTIGE_STAEDTE_UND_GEMEINDEN': 'Nachhaltige Städte und Gemeinden',
  'sdg.titles.PARTNERSCHAFTEN_ZUR_ERREICHUNG_DER_ZIELE': 'Partnerschaften zur Erreichung der Ziele',
  'sdg.titles.SAUBERES_WASSER_UND_SANITAEREINRICHTUNGEN':
    'Sauberes Wasser und Sanitäreinrichtungen',
  'sdg.titles.WENIGER_UNGLEICHHEITEN': 'Weniger Ungleichheiten',
  'team.andrea.how': `Mit Temperament und Schwung in diesem jungen Team.`,
  'team.andrea.what': `Organisation und back office`,
  'team.andrea.why': `Als passionierte "Weltverbesserin" freue ich mich, dass es respondeco nun gibt. Es ist die Bühne für alle engagierten Unternehmen und Organisationen, die mit ihren nachhaltigen Projekten zeigen wollen, dass es auch anders gehen kann.`,
  'team.antje.how': `Mit Entdeckergeist, Neugierde und der nötigen Portion Erfahrung.`,
  'team.antje.what': `Strategieentwicklerin Nachfrageseite`,
  'team.antje.why': `Weil gerade in der Privatwirtschaft kleine Schritte eine große Wirkung entfalten können. Und weil wirtschaftliche Nachhaltigkeit nur dann richtig funktioniert, wenn soziale und ökologische Aspekte berücksichtigt werden.`,
  'team.elke.how': `Lösungsorientiert, kreativ und empathisch. Aus Überzeugung und vollem Herzen.`,
  'team.elke.what': `Checkerin, Vernetzerin & creative mind`,
  'team.elke.why': `Ich liebe die Arbeit mit so vielen unterschiedlichen und motivierten Menschen, die alle für das gleiche brennen. Mit respondeco kann ich dieses Feuer und die Inspiration, die ich daraus schöpfe, auch an andere weitergeben und gemeinsam etwas bewegen und nachhaltig verändern.`,
  'team.how': 'how',
  'team.jan.how': `Mit dem Blick fürs Ganze und Wesentliche und mit viel Ausdauer und Leidenschaft.`,
  'team.jan.what': `Gründer`,
  'team.jan.why': `Ich wollte schon immer die Welt retten und respondeco ist das Beste, was mir bisher dazu eingefallen ist.`,
  'team.klaus.how': `Voller Motivation, Logik und Interesse an Neuem.`,
  'team.klaus.what': `Gründer, Geschäftsführer`,
  'team.klaus.why': `Weil mich die Idee begeistert, seit Jan mir davon erzählt hat. Weil ich damit anderen helfen kann, sich zu verwirklichen. Weil ich einen Beitrag dazu leisten möchte die Welt zu verbessern. Und ganz wichtig, es macht mir Spaß.`,
  'team.roland.how': `Mit Begeisterung für gute Ideen.`,
  'team.roland.what': `Innovation Buddha`,
  'team.roland.why': `Why not?`,
  'team.sdgbra.how': `Mit einer immer größer werdenden globalen Community.`,
  'team.sdgbra.what': `Maskottchen`,
  'team.sdgbra.why': `Ich fühle mich dort zu Hause, wo langfristig und innovativ gedacht wird und diejenigen Güter und Dienstleistungen erbracht werden, die unsere Erde und Gesellschaft brauchen. Bei respondeco ist das der Fall. Außerdem haben sie mir so wunderschöne Streifen in den Farben der 17 SDGs gegeben.`,
  'team.what': 'what',
  'team.why': 'why',
  'updates.description': 'Alles über neue Features, Verbesserungen und Fehlerbehebungen.',
  'updates.title': 'Plattform Updates',
}
